module.exports = __webpack_public_path__ + "static/media/DotsThreeOutline.fa240d9f.svg";